/*
 * Lib Module Sticks
 */

class Stick extends LibModule {

    DOMReady() {
        this.bindStickyCardTabs($(".card-header[data-sticky]"));

        $(window).on('resize', function () {
            Lib.Debounce(function () {
                $(".card-header.stuck[data-sticky]").css('width', function () {
                    return $(this).parent().width();
                });
            }, 50);

        });

        $(Lib).on('orientation.change, window.resize.end', function () {
            setTimeout(function () {
                $(".card-header.stuck[data-sticky]").css('width', function () {
                    return $(this).parent().width();
                });
            }, 200);
        });
    }

    bindStickyCardTabs(cardHeaders) {
        if (cardHeaders.length) {
            cardHeaders.each(function () {
                new Waypoint.Sticky({
                    element: this,
                    offset: '56px',
                    handler: function (direction) {
                        if (direction === 'down') {
                            $(this.element).css('width', $(this.element).parent().width());
                        } else {
                            $(this.element).css('width', 'inherit');
                        }
                    }
                });

            });
        }
    };

    resetStickyHeight() {
        $(".card-header[data-sticky]").parent().css('height', '');
    };
}

Lib.Stick = new Stick;
